<template>
  <div class="home-wrap">
    <Head></Head>
    <div class="bg-img">
      <div class="icon-logo"></div>

      <div class="width icon-wrap">
        <div v-for="(item, index) in cates" :key="item.Id" class="item" :class="'item-' + (index + 1)"  @mouseenter="mouseenter(index)" @mouseleave="mouseleave">
          <div class="animate font-size-30 font-bold font-color-11A font-center" :class="'icon-' + (index + 1)" @click="push(item)">
            <div class="t">
              {{ item.CatalogName }}
            </div>
          </div>
           <div v-if="mouseIndex==index" class="cate-info font-size-16">
              {{ moduleDesc(item.CatalogName) }}
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";

export default {
  data() {
    return {
      sel_index: 0,
      item: {
        Id: 0,
        CatalogName: "首页",
        ParentId: 0,
        Level: 1,
        Order: 1,
      },
      cates: common.cate_fr,
      mouseIndex: 999,
    };
  },

  created() {
    //
    this.cates = common.cate_fr.filter((v) => v.CatalogType != 3);
    // let script = document.getElementById("adks-title-js");
    // // if(this.map) return;
    // // this.isBodyLoading = true;
    // if (!script) {
    //   script = document.createElement("script");
    //   script.id = "adks-title-js";
    //   script.src = "https://h5.cdn.bjadks.com/Player/adks-title.js";
    //   document.body.append(script);
    // } else {
    //   // this.marker();
    // }
    // $(function () {
    //   var x = 10;
    //   var y = 20;
    //   var newtitle = "";
    //   $(".animate.adks-title")
    //     .mouseover(function (e) {
    //       newtitle = this.title;
    //       if (!newtitle) {
    //         return
    //       }
    //       this.title = "";
    //       $(".home-wrap").append('<div id="mytitle" >' + newtitle + "</div>");
    //       $("#mytitle")
    //         .css({
    //           left: e.pageX + x + "px",
    //           top: e.pageY + y - 80 + "px",
    //           position: "absolute",
    //           zIndex: "99999",
    //           color: "#333",
    //           maxWidth: "3rem",
    //           fontSize: "14px",
    //           padding: "4px",
    //           backgroundColor: "#eee",
    //           border: "solid 1px #e9f7f6",
    //           borderRadius: "5px",
    //         })
    //         .show();
    //     })
    //     .mouseout(function () {
    //       this.title = newtitle;
    //       $("#mytitle").remove();
    //     })
    //     .mouseover(function (e) {
    //       $("#mytitle")
    //         .css({
    //           left: e.pageX + x + 10 + "px",
    //           top: e.pageY + y - 60 + "px",
    //           position: "absolute",
    //           zIndex: "99999",
    //           color: "#333",
    //           maxWidth: "3rem",
    //           fontSize: "14px",
    //           padding: "4px",
    //           backgroundColor: "#eee",
    //           border: "solid 1px #e9f7f6",
    //           borderRadius: "5px",
    //         })
    //         .show();
    //     });
    // });
  },
  methods: {
    push(res) {
      console.log(res.CatalogName);
      if (res.CatalogType == 2) {
        this.$router.push({
          name: "course",
        });
      } else {
        this.$router.push({
          name: "list",
          query: {
            id: res.Id,
            type: 1,
          },
        });
      }
    },
    moduleDesc(name) {
      switch (name) {
        case "国学文化":
          return "为少儿提供中国五千年文化的精髓，使其从中汲取知识，提高修养，建立基础";
        case "科普百科":
          return "通过自然百科、社会百科、动物百科、科学实验等内容，让少儿全方面的了解与掌握科技科学知识，培养其探索能力";
        case "艺术培养":
          return "通过绘画、音乐、乐器、舞蹈、体育全方位的艺术学习，增强审美，陶冶情操";
        case "家校共育":
          return "育儿知识、家长课程和教师培养 3 方用户群体提供服务和专业指导";
        case "绘声绘色":
          return "自主研发的精品课件及互动兴趣的视频，更加增加孩子的学习积极性";
        case "中小课堂":
          return "根据中小学阶段教学大纲，精制的学科微课程，有效牢固学科知识";
        case "益智互动":
          return "以更贴近小朋友的方式解决问题，提高各年龄段小朋友的综合素质及能力";
        default:
          return "";
      }
    },
    mouseenter(value) {
      this.mouseIndex = value;
    },
    mouseleave() {
      this.mouseIndex = 999;
    },
  },
};
</script>

<style scoped>
.home-wrap {
  position: relative;
  overflow: hidden;
}
.bg-img {
  /* position: relative; */
  background: url("../assets/home/icon-home-bg1.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 6rem;
  margin-top: -2rem;
  padding-top: 94%;
  z-index: -1;
}

.icon-logo {
  width: 6.45rem;
  height: 1.95rem;
  position: absolute;
  top: 2.23rem;
  left: calc(50% - 3.23rem);
  background-color: #000;
  z-index: 9;
  background: url("../assets/home/icon-home-logo.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.item-1 .cate-info {
  bottom: -0.1rem;
}


.item-1 {
  width: 1.95rem;
  height: 2.34rem;
  position: absolute;
  top: 0.38rem;
  left: 0.2rem;
}

.icon-1 {
  width: 1.95rem;
  height: 2.34rem;
  background: url("../assets/home/icon-hone-1.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 0.38rem;
  left: 0.2rem; */
}

.t {
  position: absolute;
  bottom: 0;
  left: 0;
  float: left;
  width: 100%;
  height: 0;
  padding-bottom: 48%;
  display: flex;
  justify-content: center;
  align-items: center;
}


.item-2 .cate-info {
  bottom: -0.1rem;
}

.item-2 {
  width: 1.64rem;
  height: 2.39rem;
  position: absolute;
  top: 0.08rem;
  left: 3.8rem;
}

.icon-2 {
  width: 1.64rem;
  height: 2.39rem;
  background: url("../assets/home/icon-hone-2.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 0.08rem;
  left: 3.8rem; */
}

.item-3 {
  width: 1.77rem;
  height: 2.32rem;
  position: absolute;
  top: -0.4rem;
  left: 6.15rem;
}

.item-3 .cate-info {
  bottom: -0.3rem;
}

.icon-3 {
  width: 1.77rem;
  height: 2.32rem;
  background: url("../assets/home/icon-hone-3.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: -0.4rem;
  left: 6.15rem; */
}

.item-7 .cate-info {
  bottom: -0.1rem;
}


.item-4 {
  width: 1.92rem;
  height: 2.85rem;
  position: absolute;
  top: -0.2rem;
  left: 9.82rem;
}

.icon-4 {
  width: 1.92rem;
  height: 2.85rem;
  background: url("../assets/home/icon-hone-4.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: -0.2rem;
  left: 9.82rem; */
}

.item-5 .cate-info {
  bottom: -0.2rem;
}

.item-5 {
  width: 1.92rem;
  height: 2.85rem;
  position: absolute;
  top: 1.57rem;
  left: 2.08rem;
}

.icon-5 {
  width: 1.92rem;
  height: 2.85rem;
  background: url("../assets/home/icon-hone-10.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 1.57rem;
  left: 2.08rem; */
}

.item-6 .cate-info {
  bottom: -0.2rem;
}


.item-6 {
  width: 1.75rem;
  height: 2.19rem;
  position: absolute;
  top: 2.36rem;
  left: 5.49rem;
}

.icon-6 {
  width: 1.75rem;
  height: 2.19rem;
  background: url("../assets/home/icon-hone-8.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 2.36rem;
  left: 5.49rem; */
}

.item-7 .cate-info {
  bottom: -0.2rem;
}


.item-7 {
   width: 1.94rem;
  height: 2.94rem;
  position: absolute;
  top: 1.3rem;
  left: 7.46rem;
}

.icon-7 {
  width: 1.94rem;
  height: 2.94rem;
  background: url("../assets/home/icon-hone-9.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 1.3rem;
  left: 7.46rem; */
}

.item-8 .cate-info {
  bottom: -0.2rem;
}

.item-8 {
   width: 1.64rem;
  height: 2.39rem;
  position: absolute;
  top: 1.84rem;
  left: 11.98rem;
}

.icon-8 {
  width: 1.64rem;
  height: 2.39rem;
  background: url("../assets/home/icon-hone-2.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 1.84rem;
  left: 11.98rem; */
}

.item-9 {
  width: 1.75rem;
  height: 2.19rem;
   position: absolute;
  top: 8.23rem;
  left: 2.78rem;
}

.icon-9 {
  width: 1.75rem;
  height: 2.19rem;
  background: url("../assets/home/icon-hone-8.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 8.23rem;
  left: 2.78rem; */
}

.item-10 {
  width: 2rem;
  height: 2.4rem;
   position: absolute;
  top: 8.93rem;
  left: 6.19rem;
}


.icon-10 {
  width: 2rem;
  height: 2.4rem;
  background: url("../assets/home/icon-hone-11.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 8.93rem;
  left: 6.19rem; */
}

.item-11 {
  width: 1.7rem;
  height: 2.33rem;
  position: absolute;
  top: 8.1rem;
  left: 12.48rem;
}


.icon-11 {
  width: 1.7rem;
  height: 2.33rem;
  background: url("../assets/home/icon-hone-6.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* position: absolute;
  top: 8.1rem;
  left: 12.48rem; */
}

.animate {
  cursor: pointer;
  position: absolute;
}

.animate:hover {
  transform: scale(1.2);
  /* z-index: 999; */
}

.icon-wrap {
  position: absolute;
  top: 5rem;
  left: calc(50% - 7rem);
  height: 1rem;
}

.icon-wrap .item {
  position: absolute;
}

.cate-info {
  position: absolute;
  z-index: 999999;
  color: #333;
  width: 4rem;
  padding: 0.08rem 0.1rem;
  background-color: #fff;
  border: solid 1px #e9f7f6;
  border-radius: 0.05rem;
  bottom: 0rem;
  left: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/view/splash.vue